/* Keeps the header cart badge in step with carts changed outside the theme's own cart code.
   The Candy Rack slider cart adds, removes and changes quantities with its own requests,
   so the theme never fires its "cart:change" event and <cart-count> / <cart-dot> go stale.
   Every cart request goes through window.fetch, so watch for them and re-read the real count. */
(() => {
  if (window.__headerCartCountSync) return;
  window.__headerCartCountSync = true;

  const nativeFetch = window.fetch.bind(window);
  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const CART_READ = /\/cart\.js(\?|$)/;

  const render = (count) => {
    if (typeof count !== 'number') return;
    document.querySelectorAll('cart-count').forEach((el) => {
      if (el.textContent.trim() !== String(count)) el.textContent = count;
    });
    document.querySelectorAll('cart-dot').forEach((el) => el.classList.toggle('is-visible', count > 0));
  };

  let pending = null;
  const refresh = () => {
    clearTimeout(pending);
    pending = setTimeout(async () => {
      try {
        const cart = await (await nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        render(cart.item_count);
      } catch (e) { /* leave the badge as it was */ }
    }, 150);
  };

  window.fetch = function (input, init) {
    const url = String((input && input.url) || input || '');
    const promise = nativeFetch(input, init);
    if (CART_WRITE.test(url)) {
      promise.then(refresh, () => {});
    } else if (CART_READ.test(url)) {
      promise.then((response) => response.clone().json().then((cart) => render(cart.item_count)).catch(() => {}), () => {});
    }
    return promise;
  };
})();
